import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/react";
var iconAdd = function iconAdd(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M19 14h-4a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1Z"
  }));
};
iconAdd.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconAddWith = function iconAddWith(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    fillRule: "evenodd",
    d: "M16.5 16 13 12h7l-3.5 4Zm-4-5.75H9.75a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-2.75a.5.5 0 0 0-.5-.5H3.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h2.75a.5.5 0 0 0 .5-.5V4.5a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v2.75a.5.5 0 0 0 .5.5h2.75a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5Z"
  }));
};
iconAddWith.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconArrow = function iconArrow(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#313D3E",
    d: "m10.506 19.916 1.903-1.953-4.744-4.67H21.31V10.55H7.665l4.744-4.682-1.903-1.953-7.95 8z"
  }));
};
iconArrow.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconAzure = function iconAzure(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M14.015 4.217 7.1 9.927 1.5 19.751l5.27.055zm.77 1.263-3.02 8.014 5.6 6.313-10.76 1.92 17.895.056Z",
    fill: "#2684FF"
  }));
};
iconAzure.defaultProps = {
  viewBox: "0 0 26 26",
  height: "26",
  width: "26"
};
var iconBitbucket = function iconBitbucket(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M2.776 3a.655.655 0 0 0-.655.76l2.781 16.886c.072.427.44.74.872.744h13.344a.655.655 0 0 0 .655-.55l2.782-17.077a.655.655 0 0 0-.655-.76L2.776 3Zm11.713 12.204h-4.26L9.076 9.18h6.445l-1.032 6.025Z",
    fill: "#2684FF"
  }));
};
iconBitbucket.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26"
};
var iconBold = function iconBold(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M13.2 9.819c.812-.577 1.381-1.525 1.381-2.404 0-1.948-1.465-3.448-3.348-3.448H6v12.066h5.894c1.75 0 3.106-1.465 3.106-3.267 0-1.31-.72-2.43-1.8-2.947ZM8.108 6.122h2.85c.788 0 1.424.577 1.424 1.293 0 .715-.636 1.292-1.425 1.292h-2.85V6.122Zm3.324 7.756H8.108v-2.585h3.324c.789 0 1.425.577 1.425 1.292 0 .716-.636 1.293-1.425 1.293Z"
  }));
};
iconBold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconCheck = function iconCheck(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "m4.016 11-.648-.946a6.202 6.202 0 0 0-.157-.22 9.526 9.526 0 0 1-.096-.133l-.511-.7a7.413 7.413 0 0 0-.162-.214l-.102-.134-.265-.346a26.903 26.903 0 0 0-.543-.687l-.11-.136a21.767 21.767 0 0 0-.442-.54l-.278-.332a8.854 8.854 0 0 0-.192-.225L.417 6.28l-.283-.324L0 5.805l1.376-1.602c.04.027.186.132.186.132l.377.272.129.095c.08.058.16.115.237.175l.37.28c.192.142.382.292.565.436l.162.126c.27.21.503.398.714.574l.477.393c.078.064.156.127.23.194l.433.375.171-.205A50.865 50.865 0 0 1 8.18 4.023a35.163 35.163 0 0 1 2.382-2.213c.207-.174.42-.349.635-.518l.328-.255.333-.245c.072-.055.146-.107.221-.159l.117-.083c.11-.077.225-.155.341-.23.163-.11.334-.217.503-.32l1.158 1.74a11.908 11.908 0 0 0-.64.55l-.065.06c-.07.062-.139.125-.207.192l-.258.249-.26.265a21.72 21.72 0 0 0-.512.539 32.626 32.626 0 0 0-1.915 2.313 52.115 52.115 0 0 0-2.572 3.746l-.392.642-.19.322-.233.382H4.016z"
  }));
};
iconCheck.defaultProps = {
  viewBox: "-1 -2 16 16"
};
var iconChevron = function iconChevron(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "m5.123 6.33-2.26 2.137 8.656 9.15 9.344-9.105-2.17-2.228-7.084 6.902z"
  }));
};
iconChevron.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconChevronDouble = function iconChevronDouble(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "m5.123 3.33-2.26 2.137 8.656 9.15 9.344-9.105-2.17-2.228-7.084 6.902z"
  }), ___EmotionJSX("path", {
    d: "m5.123 10.33-2.26 2.137 8.656 9.15 9.344-9.105-2.17-2.228-7.084 6.902z"
  }));
};
iconChevronDouble.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconCircle = function iconCircle(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }));
};
iconCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconClose = function iconClose(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M11.916 9.96 6.282 4.345 4.398 6.401l5.634 5.616-5.616 5.617 1.849 2.022 5.616-5.617 5.616 5.6 1.884-2.04L13.765 12l5.633-5.634-1.866-2.022z"
  }));
};
iconClose.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconCode = function iconCode(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M9 14.6 4.649 10 9 5.4 7.676 4 2 10l5.676 6L9 14.6Zm3 0 4.351-4.6L12 5.4 13.324 4 19 10l-5.676 6L12 14.6Z"
  }));
};
iconCode.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconCodeBlock = function iconCodeBlock(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M10.103 13.32 7.05 10l3.052-3.32-1.325-1.01L4.798 10l3.98 4.33 1.325-1.01ZM5 4h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm6.927 9.32 1.217.935 3.98-4.33-3.98-4.33-1.217 1.085L14.978 10l-3.05 3.32Z"
  }));
};
iconCodeBlock.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconDragHandle = function iconDragHandle(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M3 15v-2h18v2H3Zm0-4V9h18v2H3Z"
  }));
};
iconDragHandle.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconEye = function iconEye(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M22.557 11.492C21.13 10 16.849 6 12.395 6c-4.8 0-8.844 4-10.184 5.492a.798.798 0 0 0 0 1.081C3.55 14.043 7.616 18 12.395 18c4.756 0 8.8-3.914 10.162-5.405a.783.783 0 0 0 0-1.103Zm-10.14 4.692a4.152 4.152 0 0 1 0-8.303 4.152 4.152 0 0 1 4.15 4.151c0 2.292-1.88 4.152-4.15 4.152Zm0-2.79a1.362 1.362 0 1 0 0-2.724 1.362 1.362 0 0 0 0 2.725Z"
  }));
};
iconEye.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconFolder = function iconFolder(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M10 5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-7l-2-2Z"
  }));
};
iconFolder.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconGithub = function iconGithub(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z"
  }));
};
iconGithub.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 16 16"
};
var iconGitlab = function iconGitlab(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("g", {
    fill: "none"
  }, ___EmotionJSX("path", {
    d: "M22.616 14.971 21.52 11.5l-2.173-6.882a.37.37 0 0 0-.71 0L16.465 11.5H9.252L7.079 4.617a.37.37 0 0 0-.71 0l-2.172 6.882L3.1 14.971c-.1.317.01.664.27.86l9.487 7.094 9.487-7.094a.781.781 0 0 0 .27-.86",
    fill: "#FC6D26"
  }), ___EmotionJSX("path", {
    d: "M12.858 22.925 16.465 11.5H9.251z",
    fill: "#E24329"
  }), ___EmotionJSX("path", {
    d: "M12.858 22.925 9.251 11.5H4.197z",
    fill: "#FC6D26"
  }), ___EmotionJSX("path", {
    d: "M4.197 11.499 3.1 14.971c-.1.317.01.664.27.86l9.487 7.094L4.197 11.5z",
    fill: "#FCA326"
  }), ___EmotionJSX("path", {
    d: "M4.197 11.499H9.25L7.08 4.617a.37.37 0 0 0-.71 0l-2.172 6.882z",
    fill: "#E24329"
  }), ___EmotionJSX("path", {
    d: "M12.858 22.925 16.465 11.5h5.055z",
    fill: "#FC6D26"
  }), ___EmotionJSX("path", {
    d: "m21.52 11.499 1.096 3.472c.1.317-.01.664-.271.86l-9.487 7.094L21.52 11.5z",
    fill: "#FCA326"
  }), ___EmotionJSX("path", {
    d: "M21.52 11.499h-5.055l2.172-6.882a.37.37 0 0 1 .71 0l2.173 6.882z",
    fill: "#E24329"
  })));
};
iconGitlab.defaultProps = {
  width: "26",
  height: "26",
  xmlns: "http://www.w3.org/2000/svg"
};
var iconGitea = function iconGitea(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("g", {
    fill: "#609926"
  }, ___EmotionJSX("path", {
    d: "M622.7 149.8c-4.1-4.1-9.6-4-9.6-4s-117.2 6.6-177.9 8c-13.3.3-26.5.6-39.6.7v117.2c-5.5-2.6-11.1-5.3-16.6-7.9 0-36.4-.1-109.2-.1-109.2-29 .4-89.2-2.2-89.2-2.2s-141.4-7.1-156.8-8.5c-9.8-.6-22.5-2.1-39 1.5-8.7 1.8-33.5 7.4-53.8 26.9C-4.9 212.4 6.6 276.2 8 285.8c1.7 11.7 6.9 44.2 31.7 72.5 45.8 56.1 144.4 54.8 144.4 54.8s12.1 28.9 30.6 55.5c25 33.1 50.7 58.9 75.7 62 63 0 188.9-.1 188.9-.1s12 .1 28.3-10.3c14-8.5 26.5-23.4 26.5-23.4S547 483 565 451.5c5.5-9.7 10.1-19.1 14.1-28 0 0 55.2-117.1 55.2-231.1-1.1-34.5-9.6-40.6-11.6-42.6zM125.6 353.9c-25.9-8.5-36.9-18.7-36.9-18.7S69.6 321.8 60 295.4c-16.5-44.2-1.4-71.2-1.4-71.2s8.4-22.5 38.5-30c13.8-3.7 31-3.1 31-3.1s7.1 59.4 15.7 94.2c7.2 29.2 24.8 77.7 24.8 77.7s-26.1-3.1-43-9.1zm300.3 107.6s-6.1 14.5-19.6 15.4c-5.8.4-10.3-1.2-10.3-1.2s-.3-.1-5.3-2.1l-112.9-55s-10.9-5.7-12.8-15.6c-2.2-8.1 2.7-18.1 2.7-18.1L322 273s4.8-9.7 12.2-13c.6-.3 2.3-1 4.5-1.5 8.1-2.1 18 2.8 18 2.8L467.4 315s12.6 5.7 15.3 16.2c1.9 7.4-.5 14-1.8 17.2-6.3 15.4-55 113.1-55 113.1z"
  }), ___EmotionJSX("path", {
    d: "M326.8 380.1c-8.2.1-15.4 5.8-17.3 13.8-1.9 8 2 16.3 9.1 20 7.7 4 17.5 1.8 22.7-5.4 5.1-7.1 4.3-16.9-1.8-23.1l24-49.1c1.5.1 3.7.2 6.2-.5 4.1-.9 7.1-3.6 7.1-3.6 4.2 1.8 8.6 3.8 13.2 6.1 4.8 2.4 9.3 4.9 13.4 7.3.9.5 1.8 1.1 2.8 1.9 1.6 1.3 3.4 3.1 4.7 5.5 1.9 5.5-1.9 14.9-1.9 14.9-2.3 7.6-18.4 40.6-18.4 40.6-8.1-.2-15.3 5-17.7 12.5-2.6 8.1 1.1 17.3 8.9 21.3 7.8 4 17.4 1.7 22.5-5.3 5-6.8 4.6-16.3-1.1-22.6 1.9-3.7 3.7-7.4 5.6-11.3 5-10.4 13.5-30.4 13.5-30.4.9-1.7 5.7-10.3 2.7-21.3-2.5-11.4-12.6-16.7-12.6-16.7-12.2-7.9-29.2-15.2-29.2-15.2s0-4.1-1.1-7.1c-1.1-3.1-2.8-5.1-3.9-6.3 4.7-9.7 9.4-19.3 14.1-29-4.1-2-8.1-4-12.2-6.1-4.8 9.8-9.7 19.7-14.5 29.5-6.7-.1-12.9 3.5-16.1 9.4-3.4 6.3-2.7 14.1 1.9 19.8l-24.6 50.4z"
  })));
};
iconGitea.defaultProps = {
  viewBox: "0 0 640 640",
  className: "svg gitea-gitea",
  width: "16",
  height: "16",
  'aria-hidden': "true",
  xmlns: "http://www.w3.org/2000/svg"
};
var iconGrid = function iconGrid(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M5 3h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm11 0h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm0 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2ZM5 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2Z"
  }));
};
iconGrid.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconH1 = function iconH1(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M3 4h10v12H3V4Zm2 0v5h6V4H5Zm0 7v5h6v-5H5Zm12.068 5v-5.695h-.026l-1.612.767-.325-1.482 2.236-1.04h1.638V16h-1.911Z"
  }));
};
iconH1.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconH2 = function iconH2(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    fillRule: "evenodd",
    d: "M18.036 16h-5.532v-1.104l1.008-.912c1.704-1.524 2.532-2.4 2.556-3.312 0-.636-.384-1.14-1.284-1.14-.672 0-1.26.336-1.668.648L12.6 8.872c.588-.444 1.5-.804 2.556-.804 1.764 0 2.736 1.032 2.736 2.448 0 1.308-.948 2.352-2.076 3.36l-.72.6v.024h2.94V16ZM3 8h7v8H3V8Zm2 0v3h3V8H5Zm0 5v3h3v-3H5Z"
  }));
};
iconH2.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconHOptions = function iconHOptions(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M3 4h10v12H3V4zm2 0v5h6V4H5zm0 7v5h6v-5H5m12.874 5.91-3.493-4.117h6.986l-3.493 4.117z"
  }));
};
iconHOptions.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconHome = function iconHome(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M21 13h-2a1 1 0 0 0-1 1v6h-4v-5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v5H6v-6a1 1 0 0 0-1-1H3l9-9 9 9Z"
  }));
};
iconHome.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var iconImage = function iconImage(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M5 3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Zm2.487 7.205-2.34 3.232a1 1 0 0 0 .81 1.586h9.954a1 1 0 0 0 .792-1.611L13.297 9l-3.451 4.469-2.36-3.264ZM8.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }));
};
iconImage.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconInfoCircle = function iconInfoCircle(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
  }), ___EmotionJSX("path", {
    d: "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};
iconInfoCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  className: "bi bi-info-circle",
  viewBox: "0 0 16 16"
};
var iconItalic = function iconItalic(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M8 4.012V6h2.312l-2.925 8H5v1.988h7V14H9.953l2.925-8H15V4.012z"
  }));
};
iconItalic.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconLink = function iconLink(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "m14.683 10.315-1.256-1.253 1.253-1.254a1.767 1.767 0 0 0 0-2.503 1.765 1.765 0 0 0-2.503 0L9.67 7.81a1.766 1.766 0 0 0 0 2.504l-1.25 1.247-.625-.626a2.657 2.657 0 0 1-.002-3.756l3.135-3.136a3.543 3.543 0 0 1 5.007.009 3.544 3.544 0 0 1 .003 5.007l-1.255 1.255Zm-9.394-.626v-.003l1.252 1.249L5.29 12.19a1.767 1.767 0 0 0 0 2.505c.697.695 1.813.69 2.504 0l2.506-2.506a1.766 1.766 0 0 0 0-2.504l1.249-1.249.622.625a2.654 2.654 0 0 1 .006 3.756L9.04 15.953a3.539 3.539 0 0 1-5.004-.002 3.544 3.544 0 0 1-.003-5.008L5.29 9.69Z"
  }));
};
iconLink.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconList = function iconList(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M4.5 3h15a1.5 1.5 0 0 1 0 3h-15a1.5 1.5 0 0 1 0-3Zm0 5h15a1.5 1.5 0 0 1 0 3h-15a1.5 1.5 0 0 1 0-3Zm0 5h15a1.5 1.5 0 0 1 0 3h-15a1.5 1.5 0 0 1 0-3Zm0 5h15a1.5 1.5 0 0 1 0 3h-15a1.5 1.5 0 0 1 0-3Z"
  }));
};
iconList.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconListBulleted = function iconListBulleted(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM9 4h10v1.964H9V4Zm0 5h10v2H9V9Zm0 5h10v2H9v-2Z"
  }));
};
iconListBulleted.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconListNumbered = function iconListNumbered(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M20.014 4.023v2h-11v-2h11Zm0 5v2h-11v-2h11Zm0 5v2h-11v-2h11ZM3.604 8.985V4.23h-.018l-1.095.545-.22-1.053 1.518-.738h1.113v6H3.604Zm2.458 7.997h-4v-.835l.73-.69c1.231-1.152 1.83-1.814 1.847-2.503 0-.481-.277-.862-.928-.862-.486 0-.911.254-1.206.49l-.373-.99c.425-.335 1.084-.607 1.848-.607 1.275 0 1.978.78 1.978 1.85 0 .99-.685 1.779-1.5 2.54l-.522.455v.018h2.126v1.134Z"
  }));
};
iconListNumbered.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconMarkdown = function iconMarkdown(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M1 17V8h2.75l2.75 3.309L9.25 8H12v9H9.25v-5.162l-2.75 3.31-2.75-3.31V17H1Zm18 0-4-4.368h2.667V8h2.666v4.632H23L19 17Z"
  }));
};
iconMarkdown.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconMedia = function iconMedia(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M21 15.25V4.75C21 3.788 20.212 3 19.25 3H8.75C7.787 3 7 3.788 7 4.75v10.5c0 .962.787 1.75 1.75 1.75h10.5c.962 0 1.75-.788 1.75-1.75Zm-9.641-3.773 1.787 2.394 2.615-3.277 3.522 4.417H8.717l2.642-3.534ZM3 7v12.25c0 .962.788 1.75 1.75 1.75H17v-1.956H5.98a1 1 0 0 1-1-1V7H3Z"
  }));
};
iconMedia.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconMediaAlt = function iconMediaAlt(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M5.027 4.045h13.975a3 3 0 0 1 3 3v9.99a3 3 0 0 1-3 3H5.027a3 3 0 0 1-3-3v-9.99a3 3 0 0 1 3-3Zm2.874 8.48-4.114 5.504h16.455l-5.485-6.88-4.073 5.105-2.783-3.73ZM9.493 10a1.507 1.507 0 1 0 0-3.014 1.507 1.507 0 0 0 0 3.014Z"
  }));
};
iconMediaAlt.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconDecap = function iconDecap(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M30.73.15 0 2.95l3.67 40.21 20.03-1.83-1.99-21.86 10.71-.98c10.61-.97 19.14 7.53 20.29 20.19l19.67-1.79C70.34 14.72 51.64-1.75 30.73.15ZM73.61 49.51c0 12.72-7.73 21.95-18.37 21.95H44.49V49.47H24.38v40.42h30.86c21.02 0 38.12-18.11 38.12-40.38v-.04H73.61v.04Z",
    fill: "#FF0082",
    className: "no-fill"
  }), ___EmotionJSX("path", {
    d: "M131.65 23.71h20.01c14.41 0 24.29 9.09 24.29 23.06 0 13.97-9.88 23.06-24.29 23.06h-20.01V23.71Zm19.51 37.35c8.75 0 14.47-5.47 14.47-14.29s-5.73-14.29-14.47-14.29h-9.31v28.59h9.31v-.01ZM207.61 58.69l5.22 5.93c-3.15 3.75-7.87 5.73-13.97 5.73-11.7 0-19.32-7.71-19.32-18.25s7.68-18.25 18.12-18.25c9.56 0 17.43 6.59 17.49 17.92l-25.04 5.07c1.45 3.49 4.59 5.27 9 5.27 3.59 0 6.17-1.12 8.5-3.43v.01Zm-18.44-7.64 16.49-3.36c-.94-3.62-3.9-6.06-7.99-6.06-4.91 0-8.31 3.43-8.5 9.42ZM218.25 52.1c0-10.67 7.87-18.25 18.88-18.25 7.11 0 12.71 3.23 15.17 9.02l-7.61 4.28c-1.83-3.36-4.53-4.87-7.61-4.87-4.97 0-8.87 3.62-8.87 9.81s3.9 9.81 8.87 9.81c3.08 0 5.79-1.45 7.61-4.87l7.61 4.35c-2.45 5.67-8.05 8.96-15.17 8.96-11.01 0-18.88-7.58-18.88-18.25v.01ZM290.93 34.38v35.44h-9.38v-4.08c-2.45 3.1-6.04 4.61-10.57 4.61-9.57 0-16.93-7.11-16.93-18.25s7.36-18.25 16.93-18.25c4.15 0 7.68 1.38 10.13 4.28v-3.75h9.82ZM281.3 52.1c0-6.13-3.78-9.81-8.62-9.81S264 45.98 264 52.1c0 6.12 3.78 9.81 8.68 9.81s8.62-3.69 8.62-9.81ZM334.54 52.1c0 11.13-7.36 18.25-16.86 18.25-4.22 0-7.68-1.38-10.19-4.28V82.6h-9.82V34.38h9.38v4.08c2.45-3.1 6.1-4.61 10.63-4.61 9.5 0 16.86 7.11 16.86 18.25Zm-9.94 0c0-6.13-3.71-9.81-8.62-9.81-4.91 0-8.62 3.69-8.62 9.81 0 6.12 3.71 9.81 8.62 9.81 4.91 0 8.62-3.69 8.62-9.81Z",
    fill: "#000",
    className: "no-fill"
  }));
};
iconDecap.defaultProps = {
  width: "335",
  height: "90",
  viewBox: "0 0 335 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var iconNewTab = function iconNewTab(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("g", {
    fillRule: "evenodd"
  }, ___EmotionJSX("path", {
    d: "M4.7 20.5H15c2.1 0 3.8-1.7 3.8-3.8v-6.4c0-.5-.4-.9-.8-.9-.5 0-1 .4-1 .9v6.4a2 2 0 0 1-2 2H4.7a2 2 0 0 1-2-2V6.2c0-1.1.8-2 2-2H11c.5 0 .8-.4.8-1 0-.4-.3-.8-.8-.8H4.7C2.6 2.4.9 4.1.9 6.2v10.5c0 2 1.7 3.8 3.8 3.8z"
  }), ___EmotionJSX("path", {
    d: "M20.9 7.2V1.7h-.1v-.2l-.1-.1-.2-.2h-.1l-.2-.2h-5.7c-.5 0-.8.3-.8.8s.3 1 .8 1H18l-8 8c-.4.3-.4.8 0 1.2.3.3.9.3 1.2 0l8-8v3.2c0 .5.4.9.9.9s.8-.4.9-1z"
  })));
};
iconNewTab.defaultProps = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg"
};
var iconPage = function iconPage(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "m13.366 3 5.625 5.493L19 19.169C19 20.176 18.156 21 17.125 21H5.865C4.836 21 4 20.176 4 19.17V4.83C4 3.825 4.834 3 5.866 3h7.5ZM6.94 12.11a.94.94 0 1 0 0 1.88h9.12a.94.94 0 0 0 0-1.88H6.94Zm0 3.89a.94.94 0 1 0 0 1.88h9.12a.94.94 0 1 0 0-1.88H6.94Zm5.073-6h5.139l-5.14-5.053V10Z"
  }));
};
iconPage.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconPages = function iconPages(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M3 8h1.98v11.044a1 1 0 0 0 1 1H17V22H4.75C3.788 22 3 21.212 3 20.25V8Zm6-6h6.074L20 7.041V16a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm.94 8.11a.94.94 0 1 0 0 1.88h7.12a.94.94 0 0 0 0-1.88H9.94Zm0 3.89a.94.94 0 1 0 0 1.88h7.12a.94.94 0 1 0 0-1.88H9.94Zm4.054-6.124h4.344l-4.344-4.342v4.342Z"
  }));
};
iconPages.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconPagesAlt = function iconPagesAlt(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M21 15.25c0 .962-.788 1.75-1.75 1.75H8.75C7.787 17 7 16.212 7 15.25V4.75C7 3.788 7.787 3 8.75 3h10.5c.962 0 1.75.788 1.75 1.75v10.5ZM9 10v2h10v-2H9Zm0-4v2h10V6H9ZM3 7v12.25c0 .962.788 1.75 1.75 1.75H17v-1.956H5.98a1 1 0 0 1-1-1V7H3Z"
  }));
};
iconPagesAlt.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconQuote = function iconQuote(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M4.995 14.954h2.986l1.991-3.982V5H4v5.972h2.986l-1.99 3.982Zm7.963 0h2.986l1.991-3.982V5h-5.972v5.972h2.986l-1.99 3.982Z"
  }));
};
iconQuote.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconRefresh = function iconRefresh(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M13.3 1A9.8 9.8 0 0 0 1.1 7a9.4 9.4 0 0 0 6.2 12c5 1.5 10.3-1 12.1-5.8.2-.6-.1-1.3-.7-1.5-.7-.2-1.4.1-1.6.7a7.3 7.3 0 0 1-9 4.3 7 7 0 0 1-4.7-8.9 7.3 7.3 0 0 1 12-2.8L13 7.4c-.5.5-.3.8.3.8h5.5c.7 0 1.2-.5 1.2-1.1V1.8c0-.7-.4-.8-.9-.4l-2 2c-1-1-2.3-1.9-3.8-2.4z",
    fillRule: "evenodd"
  }));
};
iconRefresh.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
var iconScroll = function iconScroll(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M12.809 8.182a.898.898 0 1 1-1.798 0V4.058L8.576 6.494a.898.898 0 1 1-1.271-1.271l3.97-3.97a.925.925 0 0 1 1.27 0l4.026 4.026a.898.898 0 1 1-1.27 1.27l-2.492-2.49v4.123Zm.015 11.75 2.435-2.436a.899.899 0 1 1 1.27 1.271l-3.969 3.97a.896.896 0 0 1-1.27 0L7.264 18.71a.898.898 0 1 1 1.27-1.271l2.492 2.491v-4.124a.898.898 0 1 1 1.798 0v4.124Zm-.902-6.479a1.516 1.516 0 1 1 0-3.032 1.516 1.516 0 0 1 0 3.032Z"
  }));
};
iconScroll.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconSearch = function iconSearch(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M20.526 18.236a1.619 1.619 0 1 1-2.29 2.29l-3.341-3.342c-.237-.237-.666-.296-.964-.137 0 0 .04-.01-.22.108a6.881 6.881 0 1 1 3.44-3.436c-.117.258-.105.214-.105.214a.86.86 0 0 0 .138.962l3.342 3.341Zm-9.677-3.466a3.921 3.921 0 1 0 0-7.842 3.921 3.921 0 0 0 0 7.842Z"
  }));
};
iconSearch.defaultProps = {
  viewBox: "0 0 24 24"
};
var iconSettings = function iconSettings(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M18.887 12.874c.037-.287.065-.575.065-.88 0-.306-.028-.594-.065-.881l1.954-1.484a.445.445 0 0 0 .11-.575L19.1 5.944c-.111-.198-.361-.27-.565-.198l-2.306.9c-.482-.36-1-.657-1.565-.882l-.352-2.382a.448.448 0 0 0-.454-.377h-3.704a.448.448 0 0 0-.454.377l-.352 2.382a7.17 7.17 0 0 0-1.565.881l-2.306-.899a.458.458 0 0 0-.565.198L3.06 9.054a.435.435 0 0 0 .111.575l1.954 1.484a6.923 6.923 0 0 0-.064.88c0 .297.027.594.064.881l-1.954 1.484a.445.445 0 0 0-.11.575l1.851 3.11c.112.198.362.27.565.198l2.306-.9c.482.36 1 .657 1.565.882l.352 2.382a.448.448 0 0 0 .454.377h3.704a.448.448 0 0 0 .454-.377l.352-2.382a7.17 7.17 0 0 0 1.565-.881l2.306.899c.213.08.454 0 .565-.198l1.852-3.11a.445.445 0 0 0-.111-.575l-1.954-1.484Zm-6.878 2.132a3.017 3.017 0 0 1-3.013-3.013 3.017 3.017 0 0 1 3.013-3.014 3.017 3.017 0 0 1 3.014 3.014 3.017 3.017 0 0 1-3.014 3.013Z"
  }));
};
iconSettings.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconStrikethrough = function iconStrikethrough(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#7A8291",
    d: "M13.97 12.046c.073.537.04 1.11-.13 1.724-.426 1.521-1.414 2.557-2.785 2.919a4.48 4.48 0 0 1-1.144.142c-1.673 0-3.4-.832-4.375-1.8l-.42-.449 1.406-1.31.393.424c.79.783 2.428 1.457 3.65 1.136.715-.189 1.18-.704 1.425-1.575.132-.48.136-.875.024-1.211Zm-.256-7.928-1.31 1.401c-.84-.785-2.554-1.409-3.758-1.077-.687.185-1.133.656-1.366 1.437-.435 1.467.534 2.016 3.022 2.764.568.171 1.07.326 1.472.523h5.786v1.92H2.2v-1.92h4.494C5.609 8.39 4.88 7.216 5.44 5.332c.536-1.806 1.766-2.489 2.702-2.744 1.983-.534 4.35.386 5.572 1.529"
  }));
};
iconStrikethrough.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20"
};
var iconUser = function iconUser(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    fill: "#1E2532",
    fillRule: "nonzero",
    d: "M16.5 18c-3.025 0-5.5-2.634-5.5-5.854v-.292C11 8.634 13.475 6 16.5 6S22 8.634 22 11.854v.292C22 15.366 19.525 18 16.5 18ZM16 29c-3.738 0-7.192-1.689-9.39-4.335-.908-1.064-.798-2.7.302-3.601C7.736 20.409 8.753 20 9.88 20h12.645c.742 0 1.43.191 2.062.491 1.43.737 1.869 2.592.88 3.874C23.24 27.175 19.875 29 16 29Z"
  }));
};
iconUser.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
};
var iconWorkflow = function iconWorkflow(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M10 4h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm7 0h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM3 4h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z"
  }));
};
iconWorkflow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var iconWrite = function iconWrite(props) {
  return ___EmotionJSX("svg", props, ___EmotionJSX("path", {
    d: "M2.975 7.004c.002-.477.412-.947.897-.948h9.451l-.816 1.896H3.872c-.485 0-.895-.47-.897-.948Zm.017 8.97c.001.478.395 1.063.88 1.064H8.57c.01-.58.1-1.425.205-1.996H3.872c-.485.001-.879.524-.88 1.001v-.068Zm7.921-5.008.762-1.997H3.872c-.486 0-.933.521-.933.999 0 .477.447.998.933.998h7.041ZM2.95 13.041c0 .477.437.965.922.966H9.18c.096-.258.301-.716.419-.968l.445-.964H3.872c-.485 0-.921.489-.922.966Zm17.099-5.908.395-.849a2.296 2.296 0 0 0-.176-2.374 2.39 2.39 0 0 0-2.207-.984 2.368 2.368 0 0 0-1.936 1.433l-4.712 10.19a9.619 9.619 0 0 0-.699 5.953.608.608 0 0 0 .35.435c.182.081.392.071.564-.027a9.846 9.846 0 0 0 4.104-4.436l3.628-7.843.689-1.498Z"
  }));
};
iconWrite.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const iconix = iconAdd;
const images = {
  add: iconix,
  'add-with': iconAddWith,
  arrow: iconArrow,
  azure: iconAzure,
  bitbucket: iconBitbucket,
  bold: iconBold,
  check: iconCheck,
  chevron: iconChevron,
  'chevron-double': iconChevronDouble,
  circle: iconCircle,
  close: iconClose,
  code: iconCode,
  'code-block': iconCodeBlock,
  'drag-handle': iconDragHandle,
  eye: iconEye,
  folder: iconFolder,
  github: iconGithub,
  gitlab: iconGitlab,
  gitea: iconGitea,
  grid: iconGrid,
  h1: iconH1,
  h2: iconH2,
  hOptions: iconHOptions,
  home: iconHome,
  image: iconImage,
  'info-circle': iconInfoCircle,
  italic: iconItalic,
  link: iconLink,
  list: iconList,
  'list-bulleted': iconListBulleted,
  'list-numbered': iconListNumbered,
  markdown: iconMarkdown,
  media: iconMedia,
  'media-alt': iconMediaAlt,
  decap: iconDecap,
  'decap-cms': iconDecap,
  'new-tab': iconNewTab,
  page: iconPage,
  pages: iconPages,
  'pages-alt': iconPagesAlt,
  quote: iconQuote,
  refresh: iconRefresh,
  scroll: iconScroll,
  search: iconSearch,
  settings: iconSettings,
  strikethrough: iconStrikethrough,
  user: iconUser,
  workflow: iconWorkflow,
  write: iconWrite
};
export default images;